import React, {useEffect, useState} from 'react'
import {Layout} from "../components";
import styles from "../styles/Home.module.scss"
import whatWeDo from "../images/as-web-SurveyAnalytica-_16_9.png.webp"
import datamapping from "../icons/datamapping.svg"
import understanding_data from "../icons/understanddata.svg"
import understanding_data_2 from "../icons/understandData_2.svg"
import send from "../icons/send.svg";
import {doc, getFirestore, setDoc} from "firebase/firestore";
import {useWindowSize} from "../utility/useLayoutEffect";


const Products = () => {

    const [user, setUser] = useState({});
    const [message, setMessage] = useState(null);
    const [notification, setNotification] = useState(null);
    const [className, setClassName] = useState(`${styles.alert} ${styles.info}`);
    const [width] = useWindowSize()
// Initialize Firebase

    const db = getFirestore();
    const pushRecords = async (e) => {
        e.preventDefault();
        try {
            const eventRef = doc(db, `events`, user.email);
            setDoc(eventRef, {...user, type: 'demo'}, {merge: true})
            setClassName(`${styles.alert} ${styles.success}`);
            setMessage("Thanks for sharing your interest, our team will reach out to you shortly");
            setNotification({
                email: user.email,
                type: 'demo'
            })

        } catch (e) {
            setClassName(`${styles.alert} ${styles.warning}`);
            setMessage("We are facing issues in processing your request. Please drop a note to us at " +
                "support@cosmoneural.com")
            //console.error("Error adding document: ", e);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        if (message) {
            setTimeout(() => {
                setMessage(null);
            }, 3000);

        }
    }, [message]);


    return (<Layout classes={styles.body} notification={notification}>
        {message && <div className={styles.recoveryMessageOverlay}>
            <div className={className}>
                <span className={styles.closebtn}>&times;</span>
                {message}
            </div>
        </div>}

        <div style={width < 700 ? {marginTop:'60px'} : {}} className={styles.goals}>
            <div className={styles.goalsInner}>
                <div className={styles.goalsItem1}>
                    <img style={{width:'100%', height:'auto', maxWidth:'unset'}} src={whatWeDo} alt='what we do'/>
                </div>
                <div className={styles.goalsItem2}>
                    <div className={styles.content}>
                        <h3>Survey Analytica: Powerful, Free and Effective Survey Platform
                        </h3>
                        <p>
                            Survey Analytica is a free tool that anyone can use to design and publish surveys, feedback forms, polls, and quizzes for collecting information and insights from participants curated to match their target audience. This multifunctional platform comes with advanced analytics and reporting tools that allow you to discover deep insights and trends in real-time. You can integrate Survey Analytica with various applications to trigger your surveys and gather data. The platform is designed to enable all types of users to build gamified surveys with ease be it businesses, marketers, educationists, students, researchers, governmental organizations, event planners, corporate trainers, or others.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div className={styles.platform}>
            <h3>
                How Our Team Can Help
            </h3>
            <div className={styles.platformInner}>
                <div className={styles.platformItems}>
                    <div className={styles.image}>
                        <img className={styles.icon} src={datamapping} alt='data mapping'/>
                    </div>
                    <div className={styles.content}>
                        <h5>
                            Market and Industry Expertise
                        </h5>
                        <p>Our enterprise architects have global experience across diverse set of industries which helps
                            them bring rich knowledge to help catapult you ahead of the market. </p>

                    </div>
                </div>
                <div className={styles.platformItems}>
                    <div className={styles.image}>
                        <img className={styles.icon} src={understanding_data} alt='understand data'/>
                    </div>
                    <div className={styles.content}>
                        <h5>
                            Better understand your needs
                        </h5>
                        <p>Understand the full context of your needs from you and your data to ensure that accurate,
                            complete and trustworthy information is used to drive business decisions.</p>
                    </div>
                </div>
                <div className={styles.platformItems}>
                    <div className={styles.image}>
                        <img className={styles.icon} src={understanding_data_2} alt='understand data'/>
                    </div>
                    <div className={styles.content}>
                        <h5>
                            Data Driven Designs
                        </h5>
                        <p>Contextual Industry specific information based on analysis at a granular level — helping us
                            to design intelligent systems.</p>
                    </div>
                </div>
            </div>

        </div>
        <section style={{
            backgroundColor: "#FFFFFF",
            display: 'flex',
            flexDirection: "column",
            width: '100%',
            padding: '10px'
        }}>

        <div className={styles.demo}>
            <div className={styles.sendContainer}>
                <h5>We’d love to give you a demo</h5>
                <form onSubmit={pushRecords} className={styles.send}><input required type='email' value={user.email}
                                                                            onChange={(e) => setUser({
                                                                                ...user,
                                                                                email: e.target.value
                                                                            })}
                                                                            placeholder='Type your email address in here'/>
                    <button type='submit'><img
                        src={send} alt={"send"}/></button>
                </form>
            </div>
        </div>
        </section>



    </Layout>)
}

export default Products;
